export default __webpack_public_path__ + "static/media/competitive.e451dfd0.webp";